import type { ApiEndpoint } from "@/shared/api-endpoint";
import { isObject, isStringArray } from "@/shared/utils/typeGuards";
import { isSpliceSearchResult, type SpliceSearchResult } from "@/shared/splice-search.api";

export const kFetchSpliceSamplesRoute = "/fetch-splice-samples";

export const kMaxFetchSpliceSamplesUuids = 50;

export interface FetchSpliceSamplesRequestBody {
    readonly uuids: readonly string[];
}

export const isFetchSpliceSamplesRequestBody = (
    value: unknown,
): value is FetchSpliceSamplesRequestBody => isObject(value) && isStringArray(value.uuids);

export interface FetchSpliceSamplesSuccessResponse {
    readonly ok: true;
    readonly results: readonly SpliceSearchResult[];
}

export const isFetchSpliceSamplesSuccessResponse = (
    value: unknown,
): value is FetchSpliceSamplesSuccessResponse =>
    isObject(value) &&
    value.ok === true &&
    Array.isArray(value.results) &&
    value.results.every(isSpliceSearchResult);

export const kFetchSpliceSamplesEndpoint: ApiEndpoint<
    FetchSpliceSamplesRequestBody,
    FetchSpliceSamplesSuccessResponse
> = {
    route: kFetchSpliceSamplesRoute,
    label: "Fetch Splice Samples",
    source: "Atlantis",
    category: "Semantic Intent",
    description:
        "Fetches Splice sounds (metadata + descrambled preview MP3) directly from a list of sample UUIDs, no search required.",
    isRequestBody: isFetchSpliceSamplesRequestBody,
    isSuccessResponse: isFetchSpliceSamplesSuccessResponse,
};
